/**
 * @ngInject
 */

function anchorClick () {

    function link (scope, elem, attrs) {
        elem[0].addEventListener('click', function onClick (event) {

        	function onAutoKill () {
        		console.log("killed");
        	}
            var target = document.getElementById(attrs.anchorClick);
            TweenMax.to(window, 0.55, {scrollTo:{y:target.offsetTop, onAutoKill: onAutoKill, autoKill : false}});
        });
    }

    return {
        link : link
    };
}